export const vpmaxwidth = () => {
    const maxContentWidth = getComputedStyle(document.documentElement)
        .getPropertyValue('--kr-max-content-width')
        .trim();
    return !!(window.matchMedia(`(min-width: ${maxContentWidth})`).matches);
};
